import { findValidFieldId } from "./findValidFieldId";

const key = "add-children-with-engine";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = (validFieldId) => ({
	"Id": 7,
	"Title": "Children With Engine",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine":
	{
		"Id": 4,
		"Code": "EMPTY",
		"Name": "Empty"
	},
	"Children":
	[
		{
			"Id": 4,
			"Title": "Empty",
			"Operator":
			{
				"Id": 2,
				"Code": "OR",
				"Name": "Or"
			},
			"Engine":
			{
				"Id": 4,
				"Code": "EMPTY",
				"Name": "Empty"
			},
			"Conditions":
			[
				{
					"Id": 1,
					"Field":
					{
						"Id": validFieldId
					}
				}
			]
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithChildrenAndEngine = ruleJson(findValidFieldId(resp.data.Data));
	resp.data.Data.Rules.push(ruleWithChildrenAndEngine);
};

export const addChildrenWithEngine = [key, applicable, modify];